export default {
	formatNumber(number) {
		var x = number + '';
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},

	getLanguage() {
		return ((navigator.language || navigator.userLanguage).indexOf('DE') !== -1 ? 'DE' : 'EN');
	},

	routes: {
		Startpage:       '/',
		StartpageMobile: '/info',
		TermsPage:       '/termspage',
		Tickets:         '/tickets',
		News:            '/aktuelles',
	},

	isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}
};



// WEBPACK FOOTER //
// ./src/Helpers.js